"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  buildTime: '2021-06-14T17:42:21Z',
  commit: '86d440a2f0eb163d97446a72f9df823ceec9c727',
  npmInfo: {
    'solid-ui': '2.4.7',
    npm: '6.14.10',
    ares: '1.16.1',
    brotli: '1.0.9',
    cldr: '37.0',
    http_parser: '2.9.4',
    icu: '67.1',
    llhttp: '2.1.3',
    modules: '72',
    napi: '7',
    nghttp2: '1.41.0',
    node: '12.20.1',
    openssl: '1.1.1i',
    tz: '2019c',
    unicode: '13.0',
    uv: '1.40.0',
    v8: '7.8.279.23-node.45',
    zlib: '1.2.11'
  }
};
exports["default"] = _default;
//# sourceMappingURL=versionInfo.js.map